"use client";

import {
	Cancel01Icon,
	CheckmarkCircle02Icon,
} from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { motion } from "framer-motion";

import { cn } from "@/lib/utils";

type VerificationBadgeProps = {
	valid: boolean;
};

export function VerificationBadge({ valid }: VerificationBadgeProps) {
	return (
		<motion.div
			initial={{ opacity: 0, y: -8 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.3, ease: "easeOut" }}
			className={cn(
				"flex items-center gap-3 rounded-2xl border px-5 py-4",
				valid
					? "border-emerald-500/30 bg-emerald-500/10 text-emerald-700 dark:border-emerald-400/30 dark:bg-emerald-400/10 dark:text-emerald-300"
					: "border-destructive/30 bg-destructive/10 text-destructive dark:border-destructive/40 dark:bg-destructive/10",
			)}
		>
			<HugeiconsIcon
				icon={valid ? CheckmarkCircle02Icon : Cancel01Icon}
				className="size-5 shrink-0"
			/>
			<div className="flex flex-col gap-0.5">
				<span className="font-bold text-sm tracking-tight">
					{valid ? "Verified Handle" : "Verification Failed"}
				</span>
				<span className="text-xs opacity-70">
					{valid
						? "This physical handle is authentic and matches the player on record."
						: "This handle could not be verified. It may be revoked or tampered with."}
				</span>
			</div>
		</motion.div>
	);
}
